<template>
  <div>
    <coupon
      v-if="coupon"
      :coupon="coupon"
      :redeem-from-outside="true"
      @redeemFromOutside="redeem"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
// TempCoupon 元件是 Coupon 元件的二次封裝，應用在「須立即使用」優惠券的情境
// Coupon 元件是消費者已經有優惠卷實體時，用來顯示該優惠券
// TempCoupon 元件是消費者還沒有優惠券實體時，在「立即使用」的情境下，消費者會先看到優惠券資訊，確認使用後
// 才會生成實體優惠券，並標記為已使用

import couponApi from "@/apis/liff/v2/coupon";
import Coupon from "@/components/Page/Liff/CouponList/Coupon.vue";
import { mapActions } from "vuex";

export default {
  components: { Coupon },
  props: {
    redeemCodeBundleId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      coupon: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions('liffLoading', ['showLoading', 'hideLoading']),
    async init() {
      this.coupon = null;
      this.showLoading()

      try {
        this.coupon = await this.getTempCouponFromRedeemCodeBundle(this.redeemCodeBundleId);
      } catch (error) {
        console.error("Failed to fetch redeem code bundle:", error);
      }

      this.hideLoading()
    },
    // 利用優惠券的母體組成優惠券資訊，並沒實體優惠券產生
    async getTempCouponFromRedeemCodeBundle(id) {
      const redeemCodeBundle = await couponApi.getRedeemCodeBundle(id);

      return {
        redeem_code_bundle_id: redeemCodeBundle.id,
        redeem_code_bundle: redeemCodeBundle
      }
    },
    async redeem(coupon) {
      this.showLoading()

      try {
        let resp = await couponApi.redeemCouponFromRedeemCodeBundle(coupon.redeem_code_bundle_id, coupon);

        this.$swal.fire({ title: "完成使用", type: "success" }).then(() => {
          this.$emit('redeemed', resp.id);
        });
      } catch (error) {
        console.log("error", error);
        this.$swal.fire({
          title: error.response?.data?.message || "使用失敗",
          type: "error",
        })
      } finally {
        this.hideLoading()
      }
    },
  },
}
</script>
